var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-tooltip',{attrs:{"text":"Download  PDF","position":"top"}},[_c('vs-button',{staticClass:"mr-2",attrs:{"radius":"","color":"#333f50","type":"flat","icon":"picture_as_pdf"},on:{"click":_vm.exportPDF}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }